if (!customElements.get('faq-accordion')) {
  customElements.define(
    'faq-accordion',
    class FaqAccordion extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onSummaryClick);
      }

      onSummaryClick = (event) => {
        const summary = event.target.closest('.faq__header');
        if (!summary || !this.contains(summary)) return;
        const details = summary.parentElement;
        if (!details || details.tagName !== 'DETAILS') return;

        event.preventDefault();

        if (details.open) {
          this.close(details);
        } else {
          this.open(details);
        }
      };

      getContent(details) {
        return details.querySelector(':scope > .faq__content');
      }

      open(details) {
        const content = this.getContent(details);
        details.open = true;
        if (!content) return;

        content.style.height = '0px';
        const target = content.scrollHeight;

        requestAnimationFrame(() => {
          content.style.height = target + 'px';
        });

        const onEnd = (e) => {
          if (e.propertyName !== 'height' || e.target !== content) return;
          content.removeEventListener('transitionend', onEnd);
          content.style.height = 'auto';
        };
        content.addEventListener('transitionend', onEnd);
      }

      close(details) {
        const content = this.getContent(details);
        if (!content) {
          details.open = false;
          return;
        }

        content.style.height = content.scrollHeight + 'px';
        // Force reflow so the browser registers the starting height
        content.offsetHeight;

        requestAnimationFrame(() => {
          content.style.height = '0px';
        });

        const onEnd = (e) => {
          if (e.propertyName !== 'height' || e.target !== content) return;
          content.removeEventListener('transitionend', onEnd);
          details.open = false;
          content.style.height = '';
        };
        content.addEventListener('transitionend', onEnd);
      }
    }
  );
}
